import React, { useState } from 'react';
import '../css/general.css'
import '../css/styles.css'

import { Link, useLocation } from 'react-router-dom'
// import rpa from '../images/rpa.PNG'
// import ad from '../images/adv1.PNG'
// import ad from '../images/adv-1.png'
// import ad from '../images/adv4.png'
// import img1 from '../images/img1.png'
// import img2 from '../images/img2.png'
// import img3 from '../images/img3.png'
import logo from '../images/logodatawhite.png'
import flybuy from '../images/logoflybye.png'
// import twitter from '../images/svg/twitter.svg'
// import linkedin from '../images/svg/linkedin.svg'
import { FiHome, FiChevronDown, FiChevronRight } from "react-icons/fi";
import { TbGraph } from "react-icons/tb";
import { FaRegEye } from "react-icons/fa";
import { BsGlobe } from "react-icons/bs";
const RPAInfo = () => {
  const location = useLocation()
  const [activeItem, setActiveItem] = useState(null);
  const basePath = location.pathname.startsWith('/uk') ? '/uk' : '';
  const toggleSubmenu = (item) => {
    setActiveItem(activeItem === item ? null : item);
  };
  return (
    // <div className="ad">
    //   <div className="rpa-info">

    //     <img src={img1} alt=''/>
    //     <img src={img2} alt=''/>
    //     <img src={img3} alt=''/>
    //     <div className="social-container">
    //       <img className="social-logo" src={logo} alt="" />
    //       <span className="social-text">Connect On Social</span>
    //       <a
    //         href="https://twitter.com/Data_Scalp"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         className="social-button-container"
    //       >
    //         <nobr className="social-button-text">Follow us on Twitter</nobr>
    //         <img src={twitter} alt="" className="social-icons" />
    //       </a>
    //       <a
    //         href="https://www.linkedin.com/company/datascalp"
    //         className="social-button-container"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //       >
    //         <nobr className="social-button-text">Follow us on LinkedIn</nobr>
    //         <img
    //           style={{
    //             height: '40px',
    //             width: '40px',
    //           }}
    //           className="social-icons"
    //           src={linkedin}
    //           alt=""
    //         />
    //       </a>
    //     </div>
    //   </div>
    // </div>
    <div className="ad">
      <div className="sidebar">
        <Link to={`${basePath}/`}>
          <img src={logo} alt="DataScalp Logo" className="logo" />
        </Link>
        <div
          className={`nav-item ${activeItem === 'dashboard' ? 'active' : ''}`}
          onClick={() => toggleSubmenu('dashboard')}
        >
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FiHome size={20} />
              Dashboard
            </div>

            {activeItem === 'dashboard' ? (
              <FiChevronDown size={25} />
            ) : (
              <FiChevronRight size={25} />
            )}
          </span>

          {activeItem === 'dashboard' && (
            <div className="submenu">
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>One-Time Performance </p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Cancellation </p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Baggage Accuracy</p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Time to Refund</p></div>
              </Link>
            </div>
          )}
        </div>

        <div
          className={`nav-item ${activeItem === 'rankings' ? 'active' : ''}`}
          onClick={() => toggleSubmenu('rankings')}
        >
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <TbGraph size={24} />
              Rankings
            </div>
            {activeItem === 'rankings' ? (
              <FiChevronDown size={25} />
            ) : (
              <FiChevronRight size={25} />
            )}
          </span>

          {activeItem === 'rankings' && (
            <div className="submenu">
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Overall Rankings</p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p >Regional Airlines</p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Budget Airlines</p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Premium Airlines</p></div>
              </Link>
            </div>
          )}
        </div>

        {/* Insights Menu */}
        <div
          className={`nav-item ${activeItem === 'insights' ? 'active' : ''}`}
          onClick={() => toggleSubmenu('insights')}
        >
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaRegEye size={20} />
              Insights
            </div>
            {activeItem === 'insights' ? (
              <FiChevronDown size={25} />
            ) : (
              <FiChevronRight size={25} />
            )}
          </span>

          {activeItem === 'insights' && (
            <div className="submenu">
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Airport Rankings</p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Delay Patterns</p></div>
              </Link>
              <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
                <div className='submenu-item'><p>Airline Reviews</p></div>
              </Link>
            </div>
          )}
        </div>
        <div className="nav-item">
        <Link to={`${basePath}/contact`} style={{ textDecoration: 'none' }}>
          <span className='submenu-item' style={{ color: 'white' }}><BsGlobe /> Eco-Friendly</span>
          </Link>
        </div>

        <img src={flybuy} alt="DataScalp Logo" className="Flybuy-logo" />
      </div>
      <div className="rpa-info">
        {/* Add your main content here */}
      </div>
    </div>
  )
}

export default RPAInfo
